import React, { Fragment, useState } from 'react';
import PurhcaseReportListView from '../../../components/inventory/reports/Purchase_rpt/PurhcaseReportListView';
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const InventoryPurchaseReportListView = () => {
  const [onURL, setOnURL] = useState(AppURL.InventoryURL + 'inventory/product/transaction/purchase/report/list/');
  const { data, loading, error, refetch } = useFetchData(onURL);

  const handleFormSuccess = (): void => {
      refetch();
  };
  return (
    <Fragment>
      <PurhcaseReportListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} data={data} loading={loading} error={error} />
    </Fragment>
  )
}

export default InventoryPurchaseReportListView